import { ObjectState } from "@homebound/form-state";
import { ApplyConfigurationFormInput } from "./applyConfigurationForm";

/**
 * Drops the chosen replacement and everything derived from it, i.e. when the configuration type
 * changes or the selection is cleared outright.
 */
export function clearSelectedConfiguration(formState: ObjectState<ApplyConfigurationFormInput>): void {
  formState.selectedConfigId.set(undefined);
  formState.readyPlanId.set(undefined);
  formState.checkoutConfigId.set(undefined);
  formState.proposedReadyPlanOptions.set([]);
}
